import { render } from "./AwardDetailMay2022Page.vue?vue&type=template&id=a85b9d0e"
import script from "./AwardDetailMay2022Page.vue?vue&type=script&lang=js"
export * from "./AwardDetailMay2022Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__